export const CONTRACT_ADDRESS = '0x90C73a89b338894eB2fA41B7cd5D9e9D5e27C98D';

export const CONTRACT_ABI = [
  {
    "inputs": [{"internalType": "uint256","name": "_points","type": "uint256"}],
    "name": "createOffer",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256","name": "_offerIndex","type": "uint256"}],
    "name": "acceptOffer",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256","name": "","type": "uint256"}],
    "name": "offers",
    "outputs": [
      {"internalType": "uint256","name": "points","type": "uint256"},
      {"internalType": "address","name": "seller","type": "address"},
      {"internalType": "uint256","name": "sellerCollateral","type": "uint256"},
      {"internalType": "address","name": "buyer","type": "address"},
      {"internalType": "uint256","name": "buyerCollateral","type": "uint256"},
      {"internalType": "enum LiquiMarkets.Offer_Status","name": "status","type": "uint8"}
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256","name": "_offerIndex","type": "uint256"}],
    "name": "cancelOffer",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "address","name": "account","type": "address"}],
    "name": "balanceOf",
    "outputs": [{"internalType": "uint256","name": "","type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "liquidToken",
    "outputs": [{"internalType": "address","name": "","type": "address"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256","name": "_offerIndex","type": "uint256"}],
    "name": "settle",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256","name": "_offerIndex","type": "uint256"}],
    "name": "claimTokens",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];